import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function Header({ rightSlot = null }) {
    return (
        <header className="sticky top-0 z-40 w-full bg-white/80 backdrop-blur-xl border-b border-[#E2E8F0]" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-2.5 group" data-testid="logo-home-link">
                    <div className="h-9 w-9 rounded-xl bg-[#064E3B] flex items-center justify-center shadow-[0_4px_12px_rgba(6,78,59,0.25)] group-hover:scale-105 transition-transform">
                        <ShieldCheck className="w-5 h-5 text-white" strokeWidth={2} />
                    </div>
                    <div className="flex flex-col leading-none">
                        <span className="font-display font-semibold text-[#022C22] text-base tracking-tight">SINPE-Flow</span>
                        <span className="text-[10px] uppercase tracking-widest text-[#64748B]">Pagos verificados</span>
                    </div>
                </Link>
                <div className="flex items-center gap-3">
                    {rightSlot}
                </div>
            </div>
        </header>
    );
}
